import * as React from "react";
import PropTypes from 'prop-types';

const SvgLogout = props => {
  if (props.id !== "_svglogout") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fill="#727272" fillRule="evenodd" d="M8.63 7c-1.285 0-2.38.437-3.28 1.312C4.45 9.188 4 10.25 4 11.5v9c0 1.25.45 2.313 1.35 3.187.9.875 1.995 1.313 3.28 1.313h3.478c.16 0 1.02-.01 1.02-1.01s-.86-1-1.02-1H8.052c-.42 0-1.17-.418-1.552-.987-.381-.569-.494-1.57-.494-1.977v-9.005c0-.407.455-1.143.767-1.423.31-.28.86-.59 1.279-.59h4.09c.234-.003 1.12-.055 1.12-.992 0-.992-.993-1.016-1.154-1.016H8.63zm11.922 1.851a.77.77 0 00-.061 1.088l5.3 5.945H9.655a.77.77 0 100 1.542H25.79l-5.299 5.945a.767.767 0 00.061 1.088.77.77 0 001.087-.062l5.758-6.458a1.93 1.93 0 000-2.568L21.64 8.912a.768.768 0 00-1.087-.06z" /></svg>;
};

SvgLogout.displayName = "_svglogout";
SvgLogout.propTypes = {
  id: PropTypes.string
};
SvgLogout.defaultProps = {
  id: ''
};
export default SvgLogout;